import { render, staticRenderFns } from "./EditDocument.vue?vue&type=template&id=df41b270&scoped=true&"
import script from "./EditDocument.vue?vue&type=script&lang=ts&"
export * from "./EditDocument.vue?vue&type=script&lang=ts&"
import style0 from "./EditDocument.vue?vue&type=style&index=0&id=df41b270&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df41b270",
  null
  
)

export default component.exports